










import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import Chart from 'chart.js';
import _ from 'lodash';
import { utilService } from '../util-service';
import chartUtil from './util.service';
import SwChartChartJsMixin from './sw-chart-chart-js.mixin.vue';
import { DoughnutroundedOptions } from './types';

@Component
export default class SwChartGaugeDonut extends mixins(SwChartChartJsMixin) {
  /** will be showing ellipsis '...' if it is INFINITE */
  @Prop({ type: Number, required: true })
  value: number;

  @Prop({ type: Number, default: 100 })
  limit: number;

  @Prop({ type: Boolean, default: true })
  showPercentage: boolean;

  @Prop({ type: String, default() { return utilService.colorConst.chartPrimaryPalette[0]; } })
  color: string;

  @Prop(String)
  baseColor: string;

  /** optional custom label */
  @Prop(String)
  label: string | undefined;

  @Prop({ type: Number, default: 20 })
  labelSize: number;

  get chartOptions(): Chart.ChartOptions {
    const options: Chart.ChartOptions = {
      cutoutPercentage: 78,
      legend: {
        display: false,
      },
      plugins: {
        doughnutlabel: {
          labels: [{
            text: `${this.centerLabel}`,
            font: { size: this.labelSize },
            color: chartUtil.chartTextColor(this.theme),
          }],
        },
        doughnutrounded: {
          applyToDatasets: [{
            index: 0,
            dataIndices: [0],
          }],
        } as DoughnutroundedOptions,
      },
      tooltips: {
        enabled: false,
      },
    };
    return _.merge(options, this.options);
  }

  get isInfiniteValue() {
    return this.value === Number.POSITIVE_INFINITY || this.value === Number.NEGATIVE_INFINITY;
  }

  get centerLabel(): string {
    if (this.label) { return String(this.label); }
    if (this.isInfiniteValue) {
      return '...';
    }
    if (this.showPercentage) {
      return `${Math.round(this.value / this.limit * 100)}%`;
    }
    return String(this.value);
  }

  get dataPoints(): number[] {
    if (this.isInfiniteValue) {
      return [0, 100];
    }
    return [this.value, this.limit - this.value];
  }

  get effectiveBaseColor(): string {
    return this.baseColor || chartUtil.pointBackgroundColor(this.theme);
  }

  @Watch('value')
  @Watch('limit')
  @Watch('color')
  @Watch('effectiveBaseColor')
  @Watch('chartOptions')
  private onConfigChanged() {
    if (this.chartInstance) {
      this.updateData();
      (this.chartInstance as any).options = this.chartOptions;
      this.chartInstance.update();
    }
  }

  private updateData() {
    if (this.chartInstance) {
      const dataset = this.chartInstance.data.datasets![0];
      dataset.data = this.dataPoints;
      (dataset.backgroundColor! as string[])[0] = this.color;
      (dataset.backgroundColor! as string[])[1] = this.effectiveBaseColor;
    }
  }

  created() {
    this.myCssPrefix = 'sw-chart-gauge-donut';
  }

  mounted() {
    this.initChart({
      type: 'doughnut',
      data: {
        labels: [],
        datasets: [{
          data: this.dataPoints,
          backgroundColor: [this.color, this.effectiveBaseColor],
          borderWidth: 0,
        }],
      },
      options: this.chartOptions,
    });
  }
}
